import axios from 'axios';

export type GetFavoriteListResponse = string[];

const list = async () => {
  const { data } = await axios.get<GetFavoriteListResponse>(`/favorite`);
  return data;
};

export default list;
